<template src="./move-invoices.html">
</template>

<script>
  import Vue from 'vue'
  import Loader from '@/components/misc/Loader'
  import Autocomplete from '@/components/misc/autocomplete/Autocomplete'
  import { EventBus } from '@/router/bus'

  export default {
    components: {
      Loader,
      Autocomplete
    },
    data () {
      return {
        load: false,
        errorList: [],
        invoiceIds: null,
        autoCompleteUrl_organization: Vue.$apiConfig.organizationAutocompleteGet,
        transferredInvoices: [],
        sourceOrganization: {
          id: null,
          companyNumber: null,
          taxIdNumber: null,
          name: null
        },
        targetOrganization: {
          id: null,
          companyNumber: null,
          taxIdNumber: null,
          name: null
        }
      }
    },
    computed: {
      showErrorContainer () {
        return this.transferredInvoices.length > 0
      }
    },
    methods: {
      submitActivation: function () {
        this.transferredInvoices = []

        var payload = {
          sourceOrganizationId: this.sourceOrganization.id,
          targetOrganizationId: this.targetOrganization.id,
          targetOrganizationCompanyNumber: this.targetOrganization.companyNumber,
          targetOrganizationTaxIdNumber: this.targetOrganization.taxIdNumber,
          targetOrganizationName: this.targetOrganization.name
        }

        this.load = true

        this.$http.post(Vue.$apiConfig.moveInvoicesPost, payload)
          .then(response => {
            this.transferredInvoices = response.data.payload.transferredInvoices
            this.logConsole(response)
            this.load = false
            EventBus.$emit('alert', {
              variant: 'success',
              message: 'Фактуре успешно пренете',
              errors: []
            })
          }, error => {
            this.logConsole(error)
            this.formatErrorResponse(error, 'invoices.invoiceLimitExceeded')
            this.load = false
          }
          )
          .finally(() => {
            this.sourceOrganization.companyNumber = null
            this.targetOrganization.companyNumber = null
          })
      },
      prepareResponseData (data) {
        return data.payload
      },
      sourceOrganizationResolved (organization) {
        if (!organization) { return }
        this.sourceOrganization.id = organization.id
        this.sourceOrganization.companyNumber = organization.companyNumber
        this.sourceOrganization.taxIdNumber = organization.taxIdNumber
        this.sourceOrganization.name = organization.name
      },
      targetOrganizationResolved (organization) {
        if (!organization) { return }
        this.targetOrganization.id = organization.id
        this.targetOrganization.companyNumber = organization.companyNumber
        this.targetOrganization.taxIdNumber = organization.taxIdNumber
        this.targetOrganization.name = organization.name
      }
    }
  }
</script>

<style lang="scss" type="text/scss" scoped>
  @import '~@/assets/scss/variables.scss';

  .text-dark {
    font-weight: 600;
    font-size: 12pt;
    color: $font-color-dark !important;
  }
  
  .list-container {
    height: 200px;
    overflow-y: scroll;
    overflow-x:hidden;
    font-size: 11pt;
  }
</style>



// WEBPACK FOOTER //
// MoveInvoices.vue?486a6819